import {
	SET_FORM_STATE,
	GET_RETUNE_SCRIPTS
} from '../actions/ScriptingActions.js';

const initialState = {
	retuneScripts: [],
	formState: {
		isValid: false,
		values: {
			dssEricssonExcelInputFilePath: '',
		},
		touched: {},
		errors: {},
	}
};

const scriptingReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: { ...state.formState, ...action.formState }
						};
					}
					case GET_RETUNE_SCRIPTS: {
						return {
							...state,
							retuneScripts: action.retuneScripts
						};
					}
					default: {
						return state;
					}
	}
};

export default scriptingReducer;
